import axios from "@/utils/axios.js";

// 获取活动列表
export function getActiveList(params) {
  return axios({
    url: "/activity/list",
    method: "get",
    params
  });
}

// 有效活动列表
export function getEffectActiveList(params) {
  return axios({
    url: `/activity/validList`,
    method: "get",
    params
  });
}

// 活动内容
export function getActiveContent(params) {
  return axios({
    url: "/activity/content",
    method: "get",
    params
  });
}

// 活动视频和图片
export function getActiveSourceMaterialList(params) {
  return axios({
    url: "/activity/sourceMaterialList",
    method: "get",
    params
  });
}

// 参与摄影师列表
export function getActivePhotographersList(params) {
  return axios({
    url: "/activity/photographersList",
    method: "get",
    params
  });
}

// 参与摄影师列表
export function getPhotographersSourceList(params) {
  return axios({
    url: "/activity/photographersWorks",
    method: "get",
    params
  });
}





//////////////////
// WEBPACK FOOTER
// ./src/api/active.js
// module id = Mhiw
// module chunks = 41